import 'bootstrap-select';

const formSelect = {
    buildSelectMenu() {
        $('.form-control--select').selectpicker({
            style:      'btn-select',
            dropupAuto: false
        });
    }
};

$(() => {
    formSelect.buildSelectMenu();
});

export default formSelect;
